import TableDataField from './TableDataField';

const CodeUsageDetailField = (props) => {
    const { content } = props;
    const classes = 'col-medium text-center';
    return <TableDataField extraStyling={classes}>{content}</TableDataField>;
};

export default CodeUsageDetailField;
